import { BlockBlobClient } from '@azure/storage-blob';
import { CustomFile } from 'components/features/file-uploader/types';
import { uploadedFileApi } from 'services/apis';
import mime from 'mime';
import { CreateUploadedFilePayloadDtoEntityTypeEnum } from 'libs/pinnacle-sdk';
import { v4 as uuidv4 } from 'uuid';

const getBlobName = (
  fileName: string,
  entityType: CreateUploadedFilePayloadDtoEntityTypeEnum,
  sessionId: string
) => `${entityType}/${sessionId}/${fileName}`;

export const handleUpload = async ({
  customFile,
  entityType,
  fileName,
  sessionId,
  entityId,
}: {
  customFile: CustomFile;
  entityType: CreateUploadedFilePayloadDtoEntityTypeEnum;
  fileName: string;
  sessionId?: string;
  entityId?: string;
}) => {
  const validSessionId = sessionId || uuidv4();
  const blobName = getBlobName(
    fileName,
    entityType,
    sessionId || validSessionId
  );
  const { uploadSasUrl, file } = await uploadedFileApi.createUploadedFile({
    createUploadedFilePayloadDto: {
      entityType,
      filePath: blobName,
      fileSize: customFile.size / 1024,
      entityId,
    },
  });

  const blockBlobClient = new BlockBlobClient(uploadSasUrl);

  await blockBlobClient.upload(customFile.originalFile, customFile.size, {
    blobHTTPHeaders: {
      blobContentType: mime.getType(blobName) || 'application/octet-stream',
    },
  });

  return file.fileId;
};
